import z from 'zod';
import { httpClient } from '../../common/data/httpClient';
import { productDtoSchema } from './dto';
import { UnknownApiResponseError } from '../../common/domain/unknownApiResponseError';
import resultsMappers from './resultsMappers';
import type { Product } from '../domain/models';

type ResultsApi = {
  getResults: (categoryId: string, flavourIds: string[], tasteIds: string[], mouthfeelIds: string[]) => Promise<Product[]>,
};

const getResults = async (categoryId: string, flavourIds: string[], tasteIds: string[], mouthfeelIds: string[]) => {
  const params = new URLSearchParams();
  params.append('category[]', categoryId);
  flavourIds.forEach(id => params.append('sensorywheel_flavor[]', id));
  tasteIds.forEach(id => params.append('sensorywheel_taste[]', id));
  mouthfeelIds.forEach(id => params.append('sensorywheel_mouthfeel[]', id));
  const url = `/api/sensory-wheel-products?${params.toString()}`;

  const response = await httpClient.get(url);
  if (response.status === 200) {
    const dto = z.array(productDtoSchema).parse(response.data);
    const products = dto.map(resultsMappers.mapProduct);
    // return a maximum of 18 products:
    return products.slice(0, 18);
  }

  throw new UnknownApiResponseError('Failed to fetch results');
};

const resultsApi: ResultsApi = {
  getResults,
};

export default resultsApi;
